<script>
/// CommitChart.js
import VueCharts from "vue-chartjs";
import { Line } from "vue-chartjs";

export default {
    extends: Line,
    props: ["chartData"],
    mounted() {
        let chartElement = this.$refs.canvas;
        let context = chartElement.getContext("2d");

        // Prepare gradient under line
        let underLineGradient = context.createLinearGradient(0, 0, 0, 115);
        underLineGradient.addColorStop(0, "rgba(0,190,0,0.3)");
        underLineGradient.addColorStop(1, "rgba(0,138,0,0)");

        // Prepare grid line gradient
        let gridLineGradient = context.createLinearGradient(0, 20, 0, 115);
        gridLineGradient.addColorStop(0, "rgba(0,0,0,0)");
        gridLineGradient.addColorStop(.5, "rgba(0,0,0,.3)");
        gridLineGradient.addColorStop(1, "rgba(0,0,0,0)");

        // Responsive tick label font sizes
        this.addPlugin({
            id: 'responsive-text',
            beforeDatasetsUpdate   : function(ctx) {
                let chartWidth = ctx.chart.width;
                let size = chartWidth * 2 / 100;
                // Min font size
                size = Math.max(13, size);
                // Max font size
                size = Math.min(20, size);
                ctx.scales['x-axis-0'].options.ticks.minor.fontSize = size;
            }
        });

        // Overwriting base render method with actual data.
        this.renderChart(
            {
                labels: this.$props.chartData.labels,
                datasets: [
                    {
                        data: this.$props.chartData.data,
                        backgroundColor: underLineGradient,
                        borderColor: "#008A00",
                        borderWidth: 4,
                        label: "Handicap",
                        lineTension: .1,
                        pointHitRadius: 14,
                        pointHoverRadius: 14,
                        pointRadius: this.$props.chartData.labelPointRadii,
                    }
                ]
            },
            {
                fullwidth: true,
                layout: {
                    padding: {
                        top: 0
                    }
                },
                legend: {
                    display: false
                },
                maintainAspectRatio: false,
                scales: {
                    xAxes: [
                        {
                            position: "top",
                            gridLines: {
                                color: gridLineGradient,
                                drawBorder: false,
                                tickMarkLength: 0,
                                zeroLineColor: gridLineGradient,
                            },
                            ticks: {
                                autoSkip: false,
                                fontColor: '#cccccc',
                                fontFamily: "'Roboto Condensed', sans-serif",
                                fontSize: 20,
                                fontStyle: "700",
                                maxRotation: 0,
                                userCallback: function(value, index, values) {
                                    // Strip out all tick labels except for 1st and last
                                    if(index == 0 || index == values.length - 1) {
                                        return value;
                                    }

                                    return "";
                                },
                            }
                        }
                    ],
                    yAxes: [
                        {
                            gridLines: {
                                display: false,
                            },
                            ticks: {
                                beginAtZero: true,
                                display: false
                            }
                        }
                    ],
                },
                tooltips: {
                    custom: function(tooltip) {
                        if (!tooltip) return;
                        // disable displaying the color box;
                        tooltip.displayColors = false;
                    },
                },
                animation: {
                    duration: 0.5,
                    onComplete: function() {
                        /* Add and position custom labels */
                        // Not currently used
                        return;
                        let controller = this.chart.controller;
                        let chart = controller.chart;
                        let xAxis = controller.scales["x-axis-0"];
                        //@TODO - Roboto Condensed font not rendering
                        context.font = Chart.helpers.fontString(
                            16,
                            "700",
                            "'Roboto Condensed', Roboto, sans-serif"
                        );
                        context.fillStyle = "#aaa";
                        xAxis.ticks.forEach(function(value, index) {
                            if (index == 0) {
                                let xOffset = 21;
                                let yOffset = chart.height - 68;
                                context.fillText(value, xOffset, yOffset);
                            }
                            if (index == xAxis.ticks.length - 1) {
                                let xOffset = chart.width - 85;
                                let yOffset = chart.height - 68;
                                context.fillText(value, xOffset, yOffset);
                            }
                        });
                    }
                },
            },
        );
    }
};
</script>

